import { AppBar, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Drawer, Toolbar, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ImageComponent from './ImageComponent';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/system';
import { CameraAlt } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

const VisualSearch = ({ image, selectImage, setItems, setFilters, filter, load, interLoading, api, user_id, setShow }) => {

    const { t, i18n } = useTranslation(['translation']);

    const [drawerW, setDrawerW] = useState(500);
    const [result, setResult] = useState(null);
    const [base64, setBase64] = useState(null);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [detections, setDetections] = useState(null);
    const [category, setCategory] = useState(null);
    const [price, setPrice] = useState(0);
    const [selectedDetection, setSelectedDetection] = useState(null);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [windowSize, setWindowSize] = useState(getWindowSize());

    const handleClickOpen = () => {
        //setOpen(true);
        setOpen(!open)
        setShow(open)
    };

    const handleClose = () => {
        setOpen(false);
    };

    const setMaxPrice = (preds) => {
        let prices = [];

        preds.map(p => prices.push(p.price));

        return prices.reduce((a, b) => Math.max(a, b), -Infinity);
    }

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    useEffect(() => {
        setDrawerW((windowSize.innerWidth >= 1200) ? 500 : 300);
    }, [windowSize]);

    useEffect(() => {
        const getCroppedImg = () => {
            if (selectedDetection !== null) {
                // let crop_image = new Image()
                // crop_image.src = URL.createObjectURL(image);

                // let height = selectedDetection.height
                // let width = selectedDetection.width
                // let xcenter = selectedDetection.xcenter
                // let ycenter = selectedDetection.ycenter

                // const canvas = document.createElement("canvas");

                // canvas.width = width;
                // canvas.height = height;
                // const ctx = canvas.getContext("2d");
                // ctx.clearRect(0, 0, canvas.width, canvas.height);
                // ctx.drawImage(crop_image, (xcenter - width / 2), (ycenter - height / 2), width, height, 0, 0, width, height);

                setResult(selectedDetection.embedding);

                // crop_image.onload = function () {
                //     // ctx.drawImage(crop_image, (xcenter - width / 2), (ycenter - height / 2), width, height, 0, 0, width, height);
                //     // console.log("----- Perform drop -----\n");
                //     const base64Image = canvas.toDataURL("image/jpeg");
                //     setResult(base64Image);
                //     // console.log("----- End drop -----\n");
                // }
            }
        };

        getCroppedImg();
    }, [image, selectedDetection])

    useEffect(() => {
        setOpen(false);
    }, [selectedDetection])

    useEffect(() => {
        setSelectedDetection(null)
        setDetections(null)

        const getBase64 = () => {
            return new Promise((resolve, reject) => {
                // console.log('----- get base 64 -----\n')
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        }

        getBase64()
            .then(img => {
                setBase64(img)
            })
    }, [image])

    useEffect(() => {
        var onresize = function () {
            if (windowSize.innerWidth >= 600) {
                setOpen(false);
            }
        }
        window.addEventListener("resize", onresize);
    }, [])

    useEffect(() => {
        if (base64 !== null) {
            api.visualsearch(base64, user_id, function (bb) {
                // console.log("----- chiamata visual search -----\n")
                setDetections(bb.detections)
                // console.log(bb.detections)
                if (bb.detections && bb.detections.length) {
                    setResult(bb.detections[0].embedding);
                    setSelectedDetection(bb.detections[0]);
                }
                setLoading(false);
            });
        }
    }, [base64, setItems]);

    useEffect(() => {

        const getPred = () => {
            if (result !== null) {
                // console.log('----- chiamata recommend -----\n')
                api.visualrecommend(result, user_id, 100, selectedDetection.class, function (preds) {
                    // console.log(api.format_currency(100))
                    load(false);
                    let category = [];
                    // console.log('\n----- Predizioni -----\n')
                    // console.log(preds);
                    // console.log('\n----- End -----\n')
                    if (preds.length > 0) {
                        preds.map(p => {
                            category.push(p.category_name);
                        })
                        setCategory([...new Set(category)])
                        setItems(preds);
                        setPrice(setMaxPrice(preds));
                    } else {
                        setCategory([])
                        setItems([]);
                    }
                })
            }
        }

        getPred();
    }, [setItems, result]);

    useEffect(() => {
        // console.log('Load.........')
        load(true);
    }, [result])

    return (
        <>
            <Box>
                <AppBar
                    position="fixed"
                    sx={{ backgroundColor: '#FFFFFF', display: { xs: 'block', sm: 'none' } }}
                >
                    <Toolbar>
                        {loading ?
                            <></>
                            :
                            <Button
                                onClick={handleClickOpen}
                                startIcon={<CameraAlt />}
                                sx={{
                                    color: 'black',
                                    borderColor: 'black',
                                    '&:hover': {
                                        borderColor: 'black',
                                        color: 'black',
                                        backgroundColor: '#ffffff!important',
                                    },
                                    '&:focus': {
                                        borderColor: 'black',
                                        color: 'black',
                                        backgroundColor: '#ffffff!important',
                                    }
                                }}
                            >
                                {!open ? t('open visual search') : t('close visual search')}
                            </Button>
                        }
                    </Toolbar>
                </AppBar>
            </Box>
            <Box
                sx={{ width: drawerW, flexShrink: { sm: 0 } }}
            >
                <Drawer
                    variant="permanent"
                    sx={{
                        position: 'static',
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { width: drawerW, position: 'absolute' },
                    }}
                    open={open}
                >
                    {loading ?
                        <Box display='flex' justifyContent='center' paddingTop='75%'>
                            <Stack direction="column" spacing={2}>
                                <Typography variant="h6">{t('Loading AI detections')}</Typography>
                                <Box display='flex' justifyContent='center'>
                                    <CircularProgress color="inherit" size={65} />
                                </Box>
                            </Stack>
                        </Box>
                        :
                        <ImageComponent
                            image={image}
                            detections={detections}
                            selectImage={selectImage}
                            setLoading={setLoading}
                            setItems={setItems}
                            setFilters={setFilters}
                            filter={filter}
                            price={price}
                            category={category}
                            setDetection={setSelectedDetection}
                            loading={interLoading}
                            selDet={selectedDetection}
                            api={api}
                            user_id={user_id}
                            setDets={setDetections}
                        />
                    }
                </Drawer>

            </Box>
            {
                isMobile ?
                    <Box sx={{ display: open ? 'block' : 'none', margin: 1 }}>
                        <ImageComponent
                            image={image}
                            detections={detections}
                            selectImage={selectImage}
                            setLoading={setLoading}
                            setItems={setItems}
                            setFilters={setFilters}
                            filter={filter}
                            price={price}
                            category={category}
                            setDetection={setSelectedDetection}
                            loading={interLoading}
                            selDet={selectedDetection}
                            api={api}
                            user_id={user_id}
                            setDets={setDetections}
                            setShow={setShow}
                        />
                    </Box>
                    : <></>
            }
            {/* <Dialog
                    fullScreen={fullScreen}
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                    sx={{ zIndex: 999999 }}
                >
                    <DialogContent>
                        <ImageComponent
                            image={image}
                            detections={detections}
                            selectImage={selectImage}
                            setLoading={setLoading}
                            setItems={setItems}
                            setFilters={setFilters}
                            filter={filter}
                            price={price}
                            category={category}
                            setDetection={setSelectedDetection}
                            loading={interLoading}
                            selDet={selectedDetection}
                            api={api}
                            user_id={user_id}
                            setDets={setDetections}
                        />

                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleClose}
                            sx={{
                                borderColor: 'black',
                                color: 'black',
                                '&:hover': {
                                    borderColor: 'black',
                                    color: 'black',
                                    backgroundColor: '#ffffff!important',
                                },
                                '&:focus': {
                                    borderColor: 'black',
                                    color: 'black',
                                    backgroundColor: '#ffffff!important',
                                }
                            }}
                        >
                            {t('Close')}
                        </Button>
                    </DialogActions>
                </Dialog> */}
        </>
    )
}

function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
}

export default VisualSearch